import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import History from './pages/History';
import Testimonies from './pages/Testimonies';
import Prayers from './pages/Prayers';
import Thanks from './pages/Thanks';
import ProtectedRoute from './routes/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';

const Admin = lazy(() => import('./pages/admin/Admin'));
const TestimoniesAdmin = lazy(() => import('./pages/admin/TestimoniesAdmin'));
const TestimonyEdit = lazy(() => import('./pages/admin/TestimonyEdit'));
const HistoryAdmin = lazy(() => import('./pages/admin/HistoryAdmin'));
const PrayersAdmin = lazy(() => import('./pages/admin/PrayersAdmin'));
const ThanksAdmin = lazy(() => import('./pages/admin/ThanksAdmin'));
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Suspense fallback={<LoadingSpinner label="Cargando..." />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/historia" element={<History />} />
            <Route path="/testimonios" element={<Testimonies />} />
            <Route path="/oraciones" element={<Prayers />} />
            <Route path="/agradecimientos" element={<Thanks />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/testimonies"
              element={
                <ProtectedRoute>
                  <TestimoniesAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/testimonies/edit/:id"
              element={
                <ProtectedRoute>
                  <TestimonyEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/testimonies/new"
              element={
                <ProtectedRoute>
                  <TestimonyEdit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/prayers"
              element={
                <ProtectedRoute>
                  <PrayersAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/history/edit"
              element={
                <ProtectedRoute>
                  <HistoryAdmin type="content" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/history/summary"
              element={
                <ProtectedRoute>
                  <HistoryAdmin type="summary" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/thanks"
              element={
                <ProtectedRoute>
                  <ThanksAdmin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;